var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras.groupKVDisplay.display == 1)?_c('div',{staticClass:"pc-banner new",style:({ 'background-color': _vm.extras.kvBgColor.bgColor })},[(
      _vm.extras.banner &&
      _vm.extras.banner.display == 1 &&
      _vm.extras.banner.colorOrBg == 'color'
    )?_c('div',{staticClass:"g-banner-div",style:({
      backgroundColor:
        _vm.extras && _vm.extras.banner && _vm.extras.banner.color
          ? _vm.extras.banner.color
          : _vm.defaultColor,
    })}):_vm._e(),(
      _vm.extras.banner &&
      _vm.extras.banner.display == 1 &&
      _vm.extras.banner.colorOrBg == 'src'
    )?_c('img',{staticClass:"g-banner-new",attrs:{"src":_vm.extras.banner.src}}):_vm._e(),_c('div',{staticClass:"seminar-info-new pc",class:_vm.extras.BannerText.textAlign},[_c('div',{staticClass:"content"},[(_vm.extras.textSetting.subTitle != 'hide')?_c('div',{staticClass:"seminar-title",style:({
          color:
            _vm.extras.textSetting.subTitle == 'custom'
              ? _vm.extras.textSetting.fontColor
              : '',
          'font-size':
            _vm.extras.textSetting.subTitle == 'custom'
              ? _vm.pxOrVw(_vm.extras.textSetting.fontSize)
              : '',
          'font-style':
            _vm.extras.textSetting.subTitle == 'custom'
              ? _vm.extras.textSetting.fontTilt == 'on'
                ? 'italic'
                : 'normal'
              : '',
          'font-Weight':
            _vm.extras.textSetting.subTitle == 'custom'
              ? _vm.extras.textSetting.fontWeight == 'on'
                ? '900'
                : ''
              : '',
        })},[_vm._v(" "+_vm._s(_vm.extras.textSetting.text)+" ")]):_vm._e(),(_vm.extras.textSetting.title != 'hide')?_c('div',{staticClass:"seminar-slogan",style:({
          color:
            _vm.extras.textSetting.title == 'custom'
              ? _vm.extras.textSetting.fontColor2
              : '',
          'font-size':
            _vm.extras.textSetting.title == 'custom'
              ? _vm.pxOrVw(_vm.extras.textSetting.fontSize2)
              : '',
          'font-style':
            _vm.extras.textSetting.title == 'custom'
              ? _vm.extras.textSetting.fontTilt2 == 'on'
                ? 'italic'
                : 'normal'
              : '',
          'font-Weight':
            _vm.extras.textSetting.title == 'custom'
              ? _vm.extras.textSetting.fontWeight2 == 'on'
                ? '900'
                : ''
              : '',
        })},[_vm._v(" "+_vm._s(_vm.extras.textSetting.title == "default" ? _vm.seminarInfo.title : _vm.seminarInfo.title)+" ")]):_vm._e(),_c('div',{staticClass:"semianr-time"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extras.textSetting.timeTitle != 'hide'),expression:"extras.textSetting.timeTitle != 'hide'"}],staticClass:"title",style:({
            color:
              _vm.extras.textSetting.timeTitle == 'custom'
                ? _vm.extras.textSetting.fontColor3
                : '',
            'font-size':
              _vm.extras.textSetting.timeTitle == 'custom'
                ? _vm.pxOrVw(_vm.extras.textSetting.fontSize3)
                : '',
            'font-style':
              _vm.extras.textSetting.timeTitle == 'custom'
                ? _vm.extras.textSetting.fontTilt3 == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.textSetting.timeTitle == 'custom'
                ? _vm.extras.textSetting.fontWeight3 == 'on'
                  ? 'bolder'
                  : ''
                : '',

            background: _vm.extras.textSetting.bgColor5 || '',
          })},[_vm._v(" "+_vm._s(_vm.extras.textSetting.timeTitle == "custom" ? _vm.extras.textSetting.text3 : "会议时间")+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extras.textSetting.time != 'hide'),expression:"extras.textSetting.time != 'hide'"}],staticClass:"_time",style:({
            color:
              _vm.extras.textSetting.time == 'custom'
                ? _vm.extras.textSetting.fontColor4
                : '',
            'font-size':
              _vm.extras.textSetting.time == 'custom'
                ? _vm.pxOrVw(_vm.extras.textSetting.fontSize4)
                : '',
            'font-style':
              _vm.extras.textSetting.time == 'custom'
                ? _vm.extras.textSetting.fontTilt4 == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.textSetting.time == 'custom'
                ? _vm.extras.textSetting.fontWeight4 == 'on'
                  ? 'bolder'
                  : ''
                : '',
            background: _vm.extras.textSetting.bgColor6 || '',
          })},[_vm._v(" "+_vm._s(_vm.handleTimeStamps(_vm.seminarInfo.startTime, _vm.seminarInfo.endTime))+" ")])])])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extras.groupSignUpDisplay.display == 1),expression:"extras.groupSignUpDisplay.display == 1"}],staticClass:"seminar-status-bar",class:_vm.extras.statusBar.browse,style:({
      background:
        _vm.extras.barBg.colorOrBg == 'color'
          ? _vm.extras.barBg.color
          : 'url(' + _vm.extras.barBg.src + ')',
      width: _vm.extras && _vm.extras.statusBar ? _vm.extras.statusBar.browse : '1200px',
    })},[_c('div',{staticClass:"status"},[(_vm.extras.countdown.display == 1)?_c('div',[(_vm.extras.countdown.icon != 'hide')?_c('div',{staticClass:"dot",style:({
            'background-color':
              _vm.extras.countdown.icon == 'custom' ? _vm.extras.countdown.color : '',
          })}):_vm._e(),(_vm.seminarStatus === 3)?_c('span',{style:({
            color:
              _vm.extras.countdown.text == 'custom'
                ? _vm.extras.countdown.customColor
                : '',
            'font-size':
              _vm.extras.countdown.text == 'custom'
                ? _vm.extras.countdown.fontSize + 'px'
                : '',
            'font-style':
              _vm.extras.countdown.text == 'custom'
                ? _vm.extras.countdown.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.countdown.text == 'custom'
                ? _vm.extras.countdown.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          })},[_vm._v("进行中")]):_vm._e(),(_vm.seminarStatus === 4)?_c('span',{style:({
            color:
              _vm.extras.countdown.text == 'custom'
                ? _vm.extras.countdown.customColor
                : '',
            'font-size':
              _vm.extras.countdown.text == 'custom'
                ? _vm.extras.countdown.fontSize + 'px'
                : '',
            'font-style':
              _vm.extras.countdown.text == 'custom'
                ? _vm.extras.countdown.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.countdown.text == 'custom'
                ? _vm.extras.countdown.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          })},[_vm._v("已结束")]):_vm._e(),(_vm.seminarStatus === 1)?_c('span',[_c('span',{style:({
              color:
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.customColor
                  : '',
              'font-size':
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.fontSize + 'px'
                  : '',
              'font-style':
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            })},[_vm._v("距离会议开始")]),_c('span',{staticClass:"seminar-remainder-num",style:({
              color:
                _vm.extras.countdown.time == 'custom'
                  ? _vm.extras.countdown.timeCustomColor
                  : '',
              'font-size':
                _vm.extras.countdown.time == 'custom'
                  ? _vm.extras.countdown.timeFontSize + 'px'
                  : '',
              'font-style':
                _vm.extras.countdown.time == 'custom'
                  ? _vm.extras.countdown.timeFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                _vm.extras.countdown.time == 'custom'
                  ? _vm.extras.countdown.timeFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            })},[_vm._v(_vm._s(_vm.remainder.days))]),_c('span',{style:({
              color:
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.customColor
                  : '',
              'font-size':
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.fontSize + 'px'
                  : '',
              'font-style':
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            })},[_vm._v("天")]),_c('span',{staticClass:"seminar-remainder-num",style:({
              color:
                _vm.extras.countdown.time == 'custom'
                  ? _vm.extras.countdown.timeCustomColor
                  : '',
              'font-size':
                _vm.extras.countdown.time == 'custom'
                  ? _vm.extras.countdown.timeFontSize + 'px'
                  : '',
              'font-style':
                _vm.extras.countdown.time == 'custom'
                  ? _vm.extras.countdown.timeFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                _vm.extras.countdown.time == 'custom'
                  ? _vm.extras.countdown.timeFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            })},[_vm._v(_vm._s(_vm.remainder.hours))]),_c('span',{style:({
              color:
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.customColor
                  : '',
              'font-size':
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.fontSize + 'px'
                  : '',
              'font-style':
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            })},[_vm._v("时")]),_c('span',{staticClass:"seminar-remainder-num",style:({
              color:
                _vm.extras.countdown.time == 'custom'
                  ? _vm.extras.countdown.timeCustomColor
                  : '',
              'font-size':
                _vm.extras.countdown.time == 'custom'
                  ? _vm.extras.countdown.timeFontSize + 'px'
                  : '',
              'font-style':
                _vm.extras.countdown.time == 'custom'
                  ? _vm.extras.countdown.timeFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                _vm.extras.countdown.time == 'custom'
                  ? _vm.extras.countdown.timeFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            })},[_vm._v(_vm._s(_vm.remainder.minutes))]),_c('span',{style:({
              color:
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.customColor
                  : '',
              'font-size':
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.fontSize + 'px'
                  : '',
              'font-style':
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                _vm.extras.countdown.text == 'custom'
                  ? _vm.extras.countdown.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            })},[_vm._v("分")])]):_vm._e()]):_vm._e()]),(
        !_vm.isFrozen && _vm.seminarStatus !== 4 && _vm.extras.signUpSetting.display == 1
      )?_c('div',{staticClass:"seminar-btn",style:({
        background:
          _vm.extras.signUpSetting.layout == 'custom'
            ? _vm.extras.signUpSetting.colorOrBg == 'color'
              ? _vm.extras.signUpSetting.color
              : 'url(' + _vm.extras.signUpSetting.src + ')'
            : '',
        width:
          _vm.extras.signUpSetting.layout == 'custom'
            ? _vm.extras.signUpSetting.btnWidth + '%'
            : '',
        color:
          _vm.extras.signUpSetting.style == 'custom'
            ? _vm.extras.signUpSetting.customColor
            : '',
        'font-size':
          _vm.extras.signUpSetting.style == 'custom'
            ? _vm.extras.signUpSetting.fontSize + 'px'
            : '',
        'font-style':
          _vm.extras.signUpSetting.style == 'custom'
            ? _vm.extras.signUpSetting.fontTilt == 'on'
              ? 'italic'
              : 'normal'
            : '',
        'font-Weight':
          _vm.extras.signUpSetting.style == 'custom'
            ? _vm.extras.signUpSetting.fontWeight == 'on'
              ? 'bolder'
              : ''
            : '',
      })},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSetting == 1 && _vm.extras.signUpText.display == 1),expression:"isSetting == 1 && extras.signUpText.display == 1"}],staticClass:"btn",class:_vm.isSetting == 1 ? 'cursor-default' : ''},[_vm._v(" "+_vm._s(_vm.extras.signUpText.model || "立即报名")+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
          _vm.isSetting !== 1 &&
          _vm.extras.signUpText.display == 1 &&
          _vm.memberInfo.signUpStatus == 0 &&
          !_vm.isLogin &&
          _vm.seminarInfo.isOpenMember != 0 &&
          _vm.signUpUrl
        ),expression:"\n          isSetting !== 1 &&\n          extras.signUpText.display == 1 &&\n          memberInfo.signUpStatus == 0 &&\n          !isLogin &&\n          seminarInfo.isOpenMember != 0 &&\n          signUpUrl\n        "}],staticClass:"btn",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('newLogin')}}},[_vm._v(" "+_vm._s(_vm.extras.signUpText.model || "立即报名")+" ")]),(
          _vm.isSetting !== 1 &&
          _vm.extras.signUpText.display == 1 &&
          _vm.memberInfo.signUpStatus == 0 &&
          (_vm.isLogin || _vm.seminarInfo.isOpenMember == 0) &&
          _vm.signUpUrl
        )?_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.signUpText.model || "立即报名")+" ")]):_vm._e(),(
          _vm.isSetting !== 1 &&
          _vm.memberInfo.signUpStatus == 1 &&
          _vm.extras.checkedText.display == 1
        )?_c('div',{staticClass:"btn audit",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.checkText.model || "审核中...")+" ")]):_vm._e(),(
          _vm.isSetting !== 1 &&
          _vm.extras.checkedText.display == 1 &&
          (_vm.memberInfo.signUpStatus == 2 || _vm.memberInfo.signUpStatus == 3)
        )?_c('div',{staticClass:"btn registered",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.checkedText.model || "报名成功")+" ")]):_vm._e(),(
          _vm.isSetting !== 1 &&
          _vm.memberInfo.signUpStatus == 4 &&
          _vm.extras.rejectText.display == 1
        )?_c('div',{staticClass:"btn refuse",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.rejectText.model || "拒绝报名")+" ")]):_vm._e(),(_vm.seminarStatus === 2)?_c('div',{staticClass:"btn registered"},[_vm._v("会议已结束")]):_vm._e()]):_vm._e()]),(_vm.showFrame)?_c('div',{staticClass:"frame-outer"},[_c('div',{staticClass:"sign-frame",style:({ transform: 'scale(' + _vm.scale + ')' })},[_c('span',{staticClass:"icontemp stemp-close",on:{"click":function($event){return _vm.close()}}}),_c('iframe',{ref:"frame",attrs:{"frameborder":"0","src":_vm.url}})])]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }